import { createSlice } from '@reduxjs/toolkit';
import { getDataBasedOnKey } from 'utils/utils';
import { produce } from '../../node_modules/immer/dist/immer';

const initialState = {
  selectedKey: [1, 2, 4],
  currentLevel: -1,
  currentData: '',
  selectedImages: [],
  inputValues: {
    groundSnowLoad: null,
    rainLoad: null,
    roofSlope: null,
    verticalExposure: null,
    horizontalExposure: null
  }
};

// this slice contains information related to fence caluator
const fenceOptionsSlice = createSlice({
  name: 'fenceOptions',
  initialState,
  reducers: {
    setSelectedKey: (state, action) => {
      const level = action.payload.level;
      const value = action.payload.value;
      const name = action.payload.name;
      const data = action.payload.data;
      state.selectedDropdownValues[name] = value;
      state.currentLevel = level;
      if (data) state.currentData = data;
      state.selectedKey.set(level, {
        value: value, // selected option
        name: name,
        object: getDataBasedOnKey(value, data)
      });
      // deleting extra dropdowns when above drop down changes
      if (state.selectedKey.size > level) {
        for (const mapKey of state.selectedKey.keys()) {
          if (mapKey > level) {
            state.selectedKey.delete(mapKey);
            state.selectedImages = state.selectedImages?.slice(0, mapKey);
          }
        }
      }
    },
    setBracketOptions: (state, action) => {
      const data = action.payload.bracketOptionsData;
      state.selectedKey.clear();
      for (const [key, value] of data.selectedKeyData) {
        state.selectedKey.set(key, value);
      }
      // state.selectedKey = data.selectedKeyData;
      state.currentData = data.currentData;
      state.currentLevel = data.currentLevel;
      state.inputValues = data.inputsData;
      state.selectedImages = data.selectedImages;
    },
    setInputValues: (state, action) => {
      console.log('inputs', action.payload.name, action.payload.value);
      state.inputValues[action.payload.name] = action.payload.value;
    },
    setAllInputData: (state, action) => {
      const inputData = action.payload.inputData;
      state.inputValues = {
        groundSnowLoad: inputData.groundSnowLoad,
        rainLoad: inputData.rainLoad,
        roofSlope: inputData.roofSlope,
        verticalExposure: inputData.verticalExposure,
        horizontalExposure: inputData.horizontalExposure
      };
      state.selectedDropdownValues = {
        'Roof Type': inputData.roofType,
        'Construction Type': inputData.constructionType,
        'Snow Bracket Type': inputData.bracketType,
        'Snow Bracket Material': inputData.bracketMaterial,
        Sheathing: inputData.sheathing,
        'Fastener Type': inputData.fastenerType,
        Manufacturer: inputData.manufacturer,
        model: inputData.model,
        gauge: inputData.gauge,
        'Installation Method': inputData.installationMethod
      };
    },
    setSelectedImage: (state, action) => {
      const imageReceived = action.payload.imgData;
      return produce(state, (draft) => {
        const index = draft.selectedImages.findIndex((image) => image.label == imageReceived.label);
        if (index === -1) {
          draft.selectedImages.push(imageReceived);
        } else {
          draft.selectedImages.splice(index, 1, imageReceived);
        }
      });
    },
    removeSelectedImage: (state, action) => {
      state.selectedImages = state.selectedImages.filter((image) => image.tag !== action.image.tag);
    },
    clearFenceOptionsData: (_) => initialState
  }
});

export const {
  setSelectedKey,
  setBracketOptions,
  setSelectedImage,
  removeSelectedImage,
  clearFenceOptionsData,
  setInputValues,
  setAllInputData
} = fenceOptionsSlice.actions;
export default fenceOptionsSlice.reducer;
